.dividerLandingPage {
  background-image: url("../../assets/dividerDots.svg");
  min-height: 252px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: repeat;
  background-size: 1500px;
}
